import React from 'react';
import { rel } from '../../../../../utils/rel';
import PropTypes from 'prop-types';
import errorBoundary from '@ifeng/errorBoundary';

/**
 * 定义 LiDom 组件
 */
class LiDom extends React.PureComponent {
    static propTypes = {
        content: PropTypes.array,
    };

    /**
     * 渲染组件
     */
    render() {
        const { content } = this.props;

        const dataList = content.map((item, index) => {
            return (
                <li key={index}>
                    <a href={item.url} target="_blank" rel={rel}>
                        {item.title}
                    </a>
                </li>
            );
        });

        return [dataList];
    }
}

export default errorBoundary(LiDom);
